export default {
  title: 'PayPal (direct)',
  description:
    'Connect your own PayPal business account to take PayPal payments directly, at your own rate. Create a REST app in the PayPal Developer Dashboard and paste its Client ID and Secret below.',
  connected_description: 'Your PayPal account is connected. Payments will settle directly into it.',
  guide: {
    title: 'How to get your PayPal credentials',
    step1: 'Log in to the PayPal Developer Dashboard with your PayPal business account.',
    step2: 'Open “Apps & Credentials” and create an app (or open your existing one).',
    step3: 'Copy the app’s Client ID and Secret.',
    step4: 'Paste them below and click “Connect PayPal”.',
    environment_note:
      'Use your Live credentials for real payments — switch the Sandbox/Live toggle at the top of “Apps & Credentials”.',
    open_dashboard: 'Open the PayPal Developer Dashboard',
  },
  status: {
    connected: 'Connected',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Your PayPal REST app Client ID',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Your PayPal REST app Secret',
    },
  },
  buttons: {
    connect: 'Connect PayPal',
    disconnect: 'Disconnect',
  },
  toasts: {
    connected: 'PayPal connected successfully',
    connect_failed: 'Could not connect PayPal',
    disconnected: 'PayPal disconnected',
    disconnect_failed: 'Could not disconnect PayPal',
  },
};
